const helpers = {
    currency: function(value: number, fixed: number){
       return value.toFixed(fixed).replace(".", ",")
    },
}

export default helpers;